import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { createReduxStore } from '../../../shared/utils/store';
import { IApplicationState } from '../../../shared/types/redux';

export function createAppState() {
  const config = getConfig();

  const defaultState = config.getStrict<IApplicationState>('initialState');

  const httpApi = getHttpApi();

  return createReduxStore(
    {
      config,
      httpApi,
      logger: getLogger(),
    },
    defaultState as IApplicationState,
    true,
  );
}
